import axios from 'axios';
// import { TOKEN, USERNAME } from '../constants';
const LOCAL_URL = process.env.REACT_APP_SID_LOCAL;

export default function(idsProforma) {
  const promises = [];
  idsProforma.map((id) => {
    const config = {
      // params: {
      //   codigo: id,
      // },
      // headers: {
      //   codUsuario: USERNAME,
      //   indPaginado: 'S',
      //   token: TOKEN,
      //   nroPag: '1',
      //   cantidadxPag: '10',
      // },
    };
    return promises.push(
      axios.get(`${LOCAL_URL}/pedidosPagos?numProforma=${id}`, config).then(result => ({ [id]: result.data }))
    );
  });
  return Promise.all(promises);
}



// WEBPACK FOOTER //
// ./src/utils/getPedidosPagos.js